<template>
  <div class="ts-flex ts-space-x-2 ts-mb-2">
    <a-button
      v-if="!isEdit"
      type="primary"
      size="small"
      class="ts-px-1 ts-w-40"
      @click="onClickBrowse"
    >
      {{ $t('purchaseOrder.fromFileImport') }}
    </a-button>
    <a-button
      v-if="!isEdit"
      size="small"
      class="ts-px-1 ts-w-40"
      @click="exportTemplate"
    >
      {{ $t('purchaseOrder.downloadTemplate') }}
    </a-button>
    <input type="file" ref="refFile" @change="fileChange" class="ts-hidden" />

    <!-- modal show pop-up to be able add product -->
    <div v-if="show_modal_export_tempalte">
      <a-modal
        v-model="show_modal_export_tempalte"
        :zIndex="1020"
        :maskClosable="false"
        width="400px"
        :title="$t('purchaseOrder.downloadTemplate')"
        :okText="$t('confirm')"
        :cancelText="$t('cancel')"
        @ok="downloadTemplate"
        @cancel="() => (show_modal_export_tempalte = false)"
        :confirmLoading="downloading_template"
      >
        <ts-loading-banner :loading="loading" class="ts-space-y-2">
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('purchaseOrder.category') }}</label>
              <a-select
                show-search
                mode="multiple"
                :placeholder="$t('all')"
                v-model="export_model.category_id"
                :max-tag-count="1"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :options="productCategories"
                class="ts-w-full"
              ></a-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('purchaseOrder.group') }}</label>
              <a-select
                show-search
                mode="multiple"
                :placeholder="$t('all')"
                v-model="export_model.pro_group_id"
                :max-tag-count="1"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :options="productGroups"
                class="ts-w-full"
              ></a-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('purchaseOrder.product') }}</label>
              <a-select
                show-search
                mode="multiple"
                :placeholder="$t('all')"
                v-model="export_model.product_id"
                :max-tag-count="1"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                @search="handleSearchProduct"
                :options="products"
                class="ts-w-full"
              ></a-select>
            </div>
          </div>
        </ts-loading-banner>
      </a-modal>
    </div>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import * as XLSX from 'xlsx/xlsx.mjs'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { trim, includes } from 'lodash'

export default {
  name: 'excelTemplate',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_modal_export_tempalte: false,
      downloading_template: false,
      product_searching: false,
      search_product: '',
      export_model: {
        category_id: [],
        pro_group_id: [],
        product_id: []
      },
      model: {}
    }
  },
  computed: {
    ...mapState('purchaseOrderV2/order', ['edit_data', 'formViewDatas']),
    productCategories() {
      if (this.formViewDatas['productCategories']) {
        return this.formViewDatas['productCategories'].map(el => ({
          value: el.category_id,
          label: el.category_name_en + '|' + el.category_name_kh
        }))
      }
      return []
    },
    productGroups() {
      if (this.formViewDatas['productGroups']) {
        if (this.export_model.category_id.length > 0) {
          return this.formViewDatas['productGroups']
            .filter(p => includes(this.export_model.category_id, p.category_id))
            .map(el => ({
              value: el.pro_group_id,
              label: el.pro_group_name_en + '|' + el.pro_group_name_kh,
              category_id: el.category_id
            }))
        }
        return this.formViewDatas['productGroups'].map(el => ({
          value: el.pro_group_id,
          label: el.pro_group_name_en + '|' + el.pro_group_name_kh,
          category_id: el.category_id
        }))
      }
      return []
    },
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
          .filter(
            p =>
              includes(this.export_model.category_id, p.category_id) ||
              includes(this.export_model.pro_group_id, p.pro_group_id)
          )
          .filter(
            ei =>
              this.search_product
                .split(' ')
                .every(s =>
                  ei.barcode.toLowerCase().includes(s.toLowerCase())
                ) ||
              this.search_product
                .split(' ')
                .every(s =>
                  ei.product_name_en.toLowerCase().includes(s.toLowerCase())
                )
          )
          .map(el => ({
            value: el.product_id,
            label: el.barcode + '|' + el.product_name_en
          }))
          .slice(0, 20)
      }
      return []
    },
    isEdit() {
      return Object.keys(this.edit_data).length
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    handleSearchProduct(value) {
      this.search_product = value
    },
    exportTemplate() {
      this.show_modal_export_tempalte = true
    },
    onClickBrowse() {
      this.$refs.refFile.click()
    },
    fileChange(e) {
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const workbookData = this.parseWorksheetData(worksheet)
          const sliceFirstRow = workbookData.slice(1)

          if (sliceFirstRow.length) {
            sliceFirstRow.forEach(item => {
              const product = this.formViewDatas['products'].find(
                el => el.barcode == item[0].toString()
              )

              if (!product) {
                this.$toasted.error(
                  `The product not found with barcode : ${item[0]}`
                )
              } else if (product) {
                let row = {
                  product_id: product.product_id,
                  uom_id: product.uom_id,
                  uom_cat_id: product.uom_cat_id,
                  qty: item[2] ? item[2] : 1,
                  maximum_reorder_allow: product.maximum_reorder_allow,
                  alloworder: false,
                  input_currency_id: product.input_currency_id,
                  currency_id: product.currency_id,
                  fx_rate: product.fx_rate,
                  fx_rate_ratio: product.fx_rate_ratio,
                  input_cost: product.input_cost,
                  cost: product.cost,
                  input_discount_rate: item[4] ? item[4] : 0,
                  discount_rate: item[4] ? item[4] : 0,
                  discount_type: item[5] ? item[5] : '%',
                  input_total_after_discount:
                    product.input_cost * (item[2] ? item[2] : 1),
                  total_after_discount: product.cost * (item[2] ? item[2] : 1)
                }
                this.model.po_detail.push(row)
              }
            })
          }
        }
      }
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum })
          const cell = worksheet[cellAddress]

          if (cell) {
            // const cellValue = cell ? cell.v : undefined
            row[colNum] = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push(row)
        }
      }
      return jsonData
    },
    downloadTemplate() {
      this.downloading_template = true
      this.$store
        .dispatch('purchaseOrderV2/order/downloadTemplate', this.export_model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.downloading_template = false
          this.show_modal_export_tempalte = false
        })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  opacity: 1;
}
.py {
  padding: 0.45rem 0;
}
.max-h {
  min-height: 30vh;
  max-height: 50vh;
}
table {
  position: relative;
  border-collapse: collapse;
}
table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
  text-transform: uppercase;
  border-width: 1px;
  white-space: nowrap;
}

table tbody tr td {
  padding: 4px 5px;
  border-width: 1px;
}

table tfoot tr {
  background-color: #e3e8f1;
  border-width: 1px;
}

table tfoot tr td {
  padding: 0 5px;
  white-space: nowrap;
  color: #c53030;
}

.total-footer .form-control {
  font-weight: 900;
  color: #c53030;
}
</style>
